@if (deckComponent.mainLayer.cards?.length) {
    <div class="flex flex-col items-center justify-center gap-4 text-slate-600 w-[80vw] md:w-[60vw] lg:w-[20vw]">
        <div class="flex flex-col items-center justify-center w-[80vw] h-[30vh] md:w-[60vw] md:h-[30vh] lg:w-[20vw] lg:h-[10vw]">
            <canvas baseChart [type]="'pie'" [data]="chartData" [options]="chartOptions" [legend]="false"></canvas>
        </div>
        <div class="text-center w-full">
            Mana Production
        </div>
        <div class="text-sm w-full flex flex-row gap-8 items-center justify-center">
            <div class="flex items-center justify-center">
                <div (click)="onModeLandClicked()" class="text-center w-[10ch] text-ponder-light bg-slate-50 rounded shadow-sm cursor-pointer hover:bg-ponder-link hover:bg-opacity-30">
                    <div class="p-1 rounded w-full h-full text-center" [ngClass]="{ 'text-slate-50 bg-ponder-light' : isModeLandActive() }">
                        Land
                    </div>
                </div>
            </div>
            <div class="flex items-center justify-center">
                <div (click)="onModeNonlandClicked()" class="text-center w-[10ch] text-ponder-light bg-slate-50 rounded shadow-sm cursor-pointer hover:bg-ponder-link hover:bg-opacity-30">
                    <div class="p-1 rounded w-full h-full text-center" [ngClass]="{ 'text-slate-50 bg-ponder-light' : isModeNonlandActive() }">
                        Nonland
                    </div>
                </div>
            </div>
            <div class="flex items-center justify-center">
                <div (click)="onModeAllClicked()" class="text-center w-[10ch] text-ponder-light bg-slate-50 rounded shadow-sm cursor-pointer hover:bg-ponder-link hover:bg-opacity-30">
                    <div class="p-1 rounded w-full h-full text-center" [ngClass]="{ 'text-slate-50 bg-ponder-light' : isModeAllActive() }">
                        All
                    </div>
                </div>
            </div>
        </div>
        <div class="text-sm">
            {{ summary }}
        </div>
    </div>
}